<template>
  <b-row class="justify-content-xl-center">
    <b-col class="col-xl-10">
      <h3>Passwort zurücksetzen</h3>

      <div v-if="show === 'email'">
        <p>
          Sollten Sie Ihre Passwort vergessen haben, können Sie es hier zurücksetzen.
          Bitte geben Sie die Emailadresse an, mit der Sie sich registriert haben:
        </p>
        <b-form id="resetForm" @submit.prevent="initReset" autocomplete="on">

          <b-form-group label-for="email" label="Email">
            <b-form-input type="email" id="email" v-model="email"  autofocus/>
          </b-form-group>

          <b-form-group class="clearfix">
            <b-button type="button" variant="secondary" class="float-left" :to="{name: 'login', params: {email: email}}">Abbrechen</b-button>
            <b-button type="submit" variant="primary" class="float-right">Passwort zurücksetzen</b-button>
          </b-form-group>

        </b-form>
      </div>

      <div v-if="show === 'password'">
        <p>
          Bitte tragen Sie nun ein neues Passwort ein. Bitte beachten Sie die minimale Länge von 8 Zeichen.
        </p>
        <b-form id="passwordForm" @submit.prevent="changePassword" autocomplete="on">

          <b-form-group label-for="password" label="Neues Passwort">
            <b-form-input type="password" id="password" v-model="password" minlength="8" autocomplete="new-password"/>
          </b-form-group>

          <b-form-group label-for="password-confirmation" label="Neues Passwort bestätigen">
            <b-form-input type="password" id="password-confirmation" v-model="passwordConfirmation" autocomplete="new-password"/>
          </b-form-group>

          <b-form-group class="clearfix">
            <b-button type="button" variant="secondary" class="float-left" :to="{name: 'login', params: {email: email}}">Abbrechen</b-button>
            <b-button type="submit" variant="primary" class="float-right">Passwort zurücksetzen</b-button>
          </b-form-group>

        </b-form>
      </div>

      <b-card v-if="show === 'confirmInit'">
        Wir haben eine Email an {{ email }} gesendet. Bitte klicken Sie auf den darin enthaltenen Link,
        um ein neues Passwort festzulegen.
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
export default {
  name: 'PasswordReset',

  data: function () {
    return {
      show: 'email',
      email: '',
      password: '',
      token: '',
      passwordConfirmation: ''
    }
  },

  mounted: function () {
    if (this.$route.params.email) {
      this.email = this.$route.params.email
    }

    if (this.$route.query.token) {
      this.show = 'password'
      this.token = this.$route.query.token
    }
  },

  methods: {
    initReset: function () {
      if (this.email.indexOf('@') === -1) {
        this.$eventHub.$emit('alertError', 'Bitte geben Sie Ihre Emailadresse ein')
        return
      }

      this.axios.post('/auth/reset', JSON.stringify({email: this.email})).then(() => {
        this.$eventHub.$emit('alertHide')
        this.show = 'confirmInit'
      }).catch((error) => {
        this.$eventHub.$emit('alertError', error)
      })
    },

    changePassword: function () {
      let body = JSON.stringify({
        token: this.token,
        password: this.password
      })

      this.axios.post('/auth/password', body).then((rsp) => {
        this.handleResponse(rsp)
      }).catch((error) => {
        this.$eventHub.$emit('alertError', error)
      })
    },

    handleResponse: function (rsp) {
      if (rsp.status === 204) {
        this.$eventHub.$emit('alertInfo', 'Passwort erfolgreich aktualisiert')
        return
      }

      localStorage.setItem('auth', JSON.stringify(rsp.data))
      this.axios.get('/users/me').then((rsp) => {
        localStorage.setItem('user', JSON.stringify(rsp.data))
        this.$router.push({name: 'teacher.dashboard', params: {from: 'passwordReset'}})
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/guests/auth/Password.vue